import React from 'react';
import CookbookFavMealsContainer from './CookbookFavMealsContainer';
import {
  useTimestamp,
  CookbookMealListConnectorApollo,
  AddFavoriteCookbookMealConnectorApollo,
  RemoveFavoriteCookbookMealConnectorApollo,
} from '@front-activerse/common-components';

export const CookbookMealListPage: React.FC = () => {
  const { timestamp1 } = useTimestamp();

  return (
    <CookbookMealListConnectorApollo searchCriteria={{ favoriteMeals: true }} key={timestamp1}>
      {(cookbookMealListData) => (
        <AddFavoriteCookbookMealConnectorApollo>
          {({ addCookbookMealToFavorite }) => (
            <RemoveFavoriteCookbookMealConnectorApollo>
              {({ removeCookbookMealFromFavorites }) => (
                <CookbookFavMealsContainer
                  {...cookbookMealListData}
                  addToFavorites={addCookbookMealToFavorite}
                  removeFromFavorites={removeCookbookMealFromFavorites}
                  key={timestamp1}
                />
              )}
            </RemoveFavoriteCookbookMealConnectorApollo>
          )}
        </AddFavoriteCookbookMealConnectorApollo>
      )}
    </CookbookMealListConnectorApollo>
  );
};

export default CookbookMealListPage;
